module.exports = {
      id: "icon-video-usage",
      viewBox: "0 0 63.3 63.3",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#icon-video",
      toString: function () {
        return this.url;
      }
    }